export const extractContent = ({ block, options, className, defaultPadding, padding, isTheme, version, children, ...content }) => content;
//# sourceMappingURL=extractContent.js.map